const detail = {
  name: 'examPracticeReportDetail',
  path: 'detail',
  props: true,
  component: resolve => require(['../../../../../../pages/portal/sbs/exam/practice-report/detail'], resolve)
}

export default detail
